import { Link } from 'react-router-dom';
import Form from './form/Form'
import ScrollToTop from '../common/scroll/ScrollToTop';
import footerLogo from '../assets/images/logo.png';
var bg_seven = require('../assets/images/background/bg-7.png');
const Footer = () => {
  var today = new Date(), date = today.getFullYear();  
  return (
     <>
	 {/* <!-- FOOTER START --> */}
	<footer className="site-footer footer-dark">
		
		{/* <!-- COLL-TO ACTION START --> */}
		<div className="section-full overlay-wraper site-bg-primary" style={{backgroundImage:`url(${bg_seven})`}}>
			
			<div className="section-content ">
			{/* <!-- COLL-TO ACTION START --> */}
				<div className="wt-subscribe-box">
					<div className="container">
						<div className="row">
							<div className="col-md-8">
								<div className="call-to-action-left p-tb20 p-r50">
									<h4 className="text-uppercase m-b10">For all admissions-related enquiries and to register your son, please contact the Admissions Office</h4>
									<p>We strongly encourage all prospective parents to attend the School’s Open Day Visit along with their sons, so the entire family can visit the campus and experience firsthand the opportunities the School has to offer.</p>
								</div>
							</div>
							
							<div className="col-md-3">
								<div className="call-to-action-right p-tb30">
									<Link to="/contact" className="site-button-secondry text-uppercase radius-sm font-weight-600">
										Contact us 
									</Link>
								</div>
							</div>
						</div>
					</div>
				</div>
				
			</div>
		</div>
		
		{/* <!-- FOOTER BLOCKES START --> */}   
		<div className="footer-top overlay-wraper">
			<div className="overlay-main"></div>
			<div className="container">
				<div className="row">
					{/* <!-- ABOUT COMPANY --> */}
					<div className="col-lg-3 col-md-6">  
						<div className="widget widget_about">
							<h4 className="widget-title">About Company</h4>
							<div className="logo-footer clearfix p-b15">
								<Link to="/"><img src={footerLogo} width="230" height="67" alt="" /></Link>
							</div>
							<p>{process.env.REACT_APP_SITE_TITLE}, is the best boarding school in {process.env.REACT_APP_SITE_ADDRESS} region in Rajasthan</p>  
						</div>
					</div> 
					{/* <!-- RESENT POST --> */}
					<div className="col-lg-3 col-md-6 col-sm-6">
						<div className="widget recent-posts-entry-date">
							<h4 className="widget-title">Resent Post</h4>
							<div className="widget-post-bx">
								<div className="bdr-light-blue widget-post clearfix  bdr-b-1 m-b10 p-b10">
									<div className="wt-post-date text-center text-uppercase text-white">
										<strong>20</strong>
										<span>Mar</span>
									</div>
									<div className="wt-post-info">
										<div className="wt-post-header">
											<h6 className="post-title"><Link to="/blog-single">Blog title first </Link></h6>
										</div>
										<div className="wt-post-meta">
											<ul>
												<li className="post-author"><i className="fa fa-user"></i>By Admin</li>
												<li className="post-comment"><i className="fa fa-comments"></i> 28</li>
											</ul>
										</div>
									</div>
								</div>
								<div className="bdr-light-blue widget-post clearfix  bdr-b-1 m-b10 p-b10">
									<div className="wt-post-date text-center text-uppercase text-white">
										<strong>30</strong>
										<span>Mar</span>
									</div>
									<div className="wt-post-info">
										<div className="wt-post-header">
											<h6 className="post-title"><Link to="/blog-single">Blog title first </Link></h6>
										</div>
										<div className="wt-post-meta">
											<ul>
												<li className="post-author"><i className="fa fa-user"></i>By Admin</li>
												<li className="post-comment"><i className="fa fa-comments"></i> 29</li>
											</ul>
										</div>
									</div>
								</div>
								<div className="bdr-light-blue widget-post clearfix  bdr-b-1 m-b10 p-b10">
									<div className="wt-post-date text-center text-uppercase text-white">
										<strong>31</strong>
										<span>Mar</span>
									</div>
									<div className="wt-post-info">
										<div className="wt-post-header">
											<h6 className="post-title"><Link to="/blog-single">Blog title first </Link></h6>
										</div>
										<div className="wt-post-meta">
											<ul>
												<li className="post-author"><i className="fa fa-user"></i>By Admin</li>
												<li className="post-comment"><i className="fa fa-comments"></i> 30</li>
											</ul>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>      
					{/* <!-- USEFUL LINKS --> */}
					<div className="col-lg-3 col-md-6 col-sm-6">
						<div className="widget widget_services">
							<h4 className="widget-title">Useful links</h4>
							<ul>
								<li><Link to="/about">About</Link></li>
								<li><Link to="/facility">Facility</Link></li>
								<li><Link to="/addmission">Addmission</Link></li>
								<li><Link to="/news&events">News & Events</Link></li>
								<li><Link to="/photogallery">Photo Gallery</Link></li>
								<li><Link to="/contact">Contact</Link></li>
							</ul>
						</div>
					</div>
					{/* <!-- NEWSLETTER --> */}
					<div className="col-lg-3 col-md-6">
						<div className="widget widget_newsletter">
							<h4 className="widget-title">Newsletter</h4>
							<div className="newsletter-bx">
								
									<Form />
								
							</div>
						</div>
						{/* <!-- SOCIAL LINKS --> */}
						<div className="widget widget_social_inks">
							<h4 className="widget-title">Social Links</h4>
							<ul className="social-icons social-square social-darkest">
								<li><Link to={`https://www.facebook.com/${process.env.REACT_APP_FACEBOOK_USERNAME}`} className="fa fa-facebook"></Link></li>
								<li><Link to={`https://twitter.com/${process.env.REACT_APP_TWITTER_USERNAME}`} className="fa fa-twitter"></Link></li>
								<li><Link to={`https://in.linkedin.com/${process.env.REACT_APP_LINKEDIN_USERNAME}`} className="fa fa-linkedin"></Link></li>						
								<li><Link to={`https://www.youtube.com/${process.env.REACT_APP_YOUTUBE_USERNAME}`} className="fa fa-youtube"></Link></li>
								<li><Link to={`https://www.instagram.com/${process.env.REACT_APP_INSTAGRAM_USERNAME}`} className="fa fa-instagram"></Link></li>
							</ul>
						</div>
					</div>
				</div>
				
				
				
				<div className="row">  
					  <div className="col-lg-3 col-md-6 col-sm-6 p-tb20">
						   <div className="wt-icon-box-wraper left  bdr-1 bdr-gray-dark p-tb15 p-lr10 clearfix">
								<div className="icon-md site-text-primary">
									<span className="iconmoon-travel"></span>
								</div>
								<div className="icon-content">
									<h5 className="wt-tilte text-uppercase m-b0">Address</h5>
									<p>{process.env.REACT_APP_SITE_ADDRESS}</p>
								</div>
						   </div>
						</div>
					
					   <div className="col-lg-3 col-md-6 col-sm-6 p-tb20 ">
						   <div className="wt-icon-box-wraper left  bdr-1 bdr-gray-dark p-tb15 p-lr10 clearfix ">
								<div className="icon-md site-text-primary">
									<span className="iconmoon-smartphone-1"></span>
								</div>
								<div className="icon-content">
									<h5 className="wt-tilte text-uppercase m-b0">Phone</h5>
									<p className="m-b0">{process.env.REACT_APP_SITE_CONTACT_NO}</p>
									<p className="m-b0">{process.env.REACT_APP_SITE_CONTACT_NO1}</p>
								</div>
						   </div>
					   </div>
					
					   <div className="col-lg-3 col-md-6 col-sm-6 p-tb20">
						   <div className="wt-icon-box-wraper left  bdr-1 bdr-gray-dark p-tb15 p-lr10 clearfix">
								<div className="icon-md site-text-primary">
									<span className="iconmoon-fax"></span>
								</div>
								<div className="icon-content">
									<h5 className="wt-tilte text-uppercase m-b0">Fax</h5>
									<p className="m-b0">FAX: {process.env.REACT_APP_SITE_CONTACT_FAX}</p>
									<p className="m-b0">FAX: {process.env.REACT_APP_SITE_CONTACT_FAX1}</p>
								</div>
							</div>
						</div>
					
					   <div className="col-lg-3 col-md-6 col-sm-6 p-tb20">
						   <div className="wt-icon-box-wraper left  bdr-1 bdr-gray-dark p-tb15 p-lr10 clearfix">
								<div className="icon-md site-text-primary">
									<span className="iconmoon-email"></span>
								</div>
								<div className="icon-content">
									<h5 className="wt-tilte text-uppercase m-b0">Email</h5>
									<p className="m-b0">{process.env.REACT_APP_EMAIL_ADDRESS}</p>
									
								</div>
							</div>
						</div>
				 </div>	
				
				
				
			</div>
		</div>
		{/* <!-- FOOTER COPYRIGHT --> */}
		<div className="footer-bottom overlay-wraper">
			<div className="overlay-main"></div>
			<div className="constrot-strip"></div>
			<div className="container p-t30">
				<div className="row ftr-btm">
					<div className="wt-footer-bot-left">
						<span className="copyrights-text">&#169; {date} {process.env.REACT_APP_SITE_TITLE}. All Rights Reserved. Designed By devandainfotech.com.</span>
					</div>
					<div className="wt-footer-bot-right">
						<ul className="copyrights-nav pull-right"> 
							<li><Link to="/#">Terms & Condition</Link></li>
							<li><Link to="/#">Privacy Policy</Link></li>
							<li><Link to="/contact">Contact Us</Link></li>
						</ul>
					</div>
				</div>
			</div>
		</div>
		<ScrollToTop />
	</footer>
	{/* <!-- FOOTER END --> */}
    
     </>
  );
};

export default Footer;
